"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const keautils_1 = require("keautils");
function getEffectiveString(x, string) {
    return string == undefined ? cellToText(x) : string;
}
exports.getEffectiveString = getEffectiveString;
/**Convierte una celda en el texto que se va a usar para la busqueda por texto*/
function cellToText(x) {
    if (x == null) {
        return "";
    }
    else if (typeof x == "number") {
        return "" + x;
    }
    else if (typeof x == "boolean") {
        return x ? "si" : "no";
    }
    else if (typeof x == "string") {
        return x;
    }
    else if (x instanceof Date) {
        return keautils_1.formatDate(x);
    }
    else if (x instanceof Array) {
        const y = x;
        return y.map(z => cellToText(z)).join(", ");
    }
    else if (typeof x == "object") {
        return Object.keys(x).join(" ");
    }
    ;
    return "" + x;
}
exports.cellToText = cellToText;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/simpleGrid/text.js
// module id = 81
// module chunks = 0